
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import JourneyGrid from '@/components/JourneyGrid';
import JourneyProgress from './JourneyProgress';
import { UserProgress } from '@/types/user';

interface JourneySectionProps {
  userProgress: UserProgress;
}

const JourneySection: React.FC<JourneySectionProps> = ({ userProgress }) => {
  return (
    <Card className="bg-white">
      <CardHeader>
        <CardTitle className="text-xl">30-Day Journey</CardTitle>
        <CardDescription>
          Your comprehensive hormone health program
        </CardDescription>
      </CardHeader>
      <CardContent>
        <JourneyProgress 
          currentDay={userProgress?.currentDay || 1} 
          totalDays={30} 
        />
        <JourneyGrid totalDays={30} />
      </CardContent>
    </Card>
  );
};

export default JourneySection;
